import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import * as queryString from 'query-string';
import SetPasswordForm from '../../common/SetPasswordForm';
import * as authApi from '../../../api/Auth';

interface State {
    query: {
        token: string;
        username: string;
    };
}

interface Props extends RouteComponentProps<{}> {}

class ResetPasswordPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            query: queryString.parse(props.location.search)
        };
    }

    render() {
        return (
            <SetPasswordForm
                token={this.state.query.token}
                username={this.state.query.username}
                setPassword={authApi.resetPassword}
                title="Reset your Password"
            />
        );
    }
}

export default withRouter<Props>(ResetPasswordPage);



// WEBPACK FOOTER //
// ./src/components/pages/auth/ResetPasswordPage.tsx